import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';

export const FAQSection = () => {
  return (
    <section id="faq" className="relative py-28 bg-zinc-900/30">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#50ced4]/20 to-transparent" />

      <div className="max-w-3xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="text-[#50ced4] text-sm font-medium tracking-widest uppercase mb-4 block">FAQ</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-5 leading-tight">
            Frequently Asked{' '}
            <span className="text-[#50ced4]">Questions</span>
          </h2>
          <p className="text-zinc-400 text-lg leading-relaxed">
            Everything you need to know about our sound hire services.
          </p>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border border-white/5 rounded-xl bg-zinc-900/50 px-6 overflow-hidden data-[state=open]:border-[#50ced4]/20"
            >
              <AccordionTrigger className="text-white hover:text-[#50ced4] text-left font-medium py-5 hover:no-underline text-base">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 text-sm leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
